import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { UIRouter }                        from '@uirouter/core';
import { LegacyUibModalService }          from '../../../app-lite/modals/legacy-uib-modal.service';
import { TranslateService }               from '@ngx-translate/core';

import InvoicesForBillerPaymentHtml from '../../../app-lite/invoices/invoices.for-biller-payment.html';
import InvoicesForPaymentHtml       from '../../../app-lite/invoices/invoices.for-payment.html';
import WindowFlipHtml               from '../../../app-lite/core/templates/window-flip.html';

import { API }                     from '../../../app-lite/api/api.constant';
import { ApiService }              from '../../../app-lite/api/api.service';
import { AssemblyPaymentsService } from '../../assembly-payments/assembly-payments.service';
import { BigDecimalService }       from '../../../app-lite/core/services/big-decimal.service';
import { BillerService }           from '../../../app-lite/biller/biller.service';
import { CompanyService }          from '../../../app-lite/companies/company.service';
import { ConfirmService }          from '../../../app-lite/messages/confirm/confirm.service';
import { CustomerFactoryService }  from '../../../app-lite/customers/customer-factory.service';
import { CustomerPaymentsService } from '../../../app-lite/customer-payments/customer-payments.service';
import { DateParserService }       from '../../../app-lite/core/services/date-parser.service';
import { MessagesService }         from '../../../app-lite/messages/messages.service';
import { MessengerService }        from '../../../app-lite/messages/messenger/messenger.service';
import { SessionService }          from '../../../app-lite/sessions/session.service';
import { StreamSearchService }     from '../../../app-lite/api/stream-search.service';
import { TableService }            from '../../../app-lite/table/table.service';
import { TillpaymentsService }     from '../../../app-lite/tillpayments/tillpayments.service';

import { CustomerPaymentEmailReceiptComponent } from '../../../app-lite/customer-payments/customer-payment.email-receipt.component';

declare var BigDecimal: any;

@Component({
  selector   : 'wor-customer-payment',
  template: require('./customer-payment.component.html')
})
export class CustomerPaymentComponent implements OnInit {
  @Input() companyMessages: any;
  @Input() customer: any;
  @Input() integrations: any;
  @Input() lostTerminalTransaction: any;
  @Input() payment: any;
  @Input() pos_terminals: any[];

  API = API;
  balance = '0';
  company: any;
  creditsToApply: boolean;
  currency: any;
  customer_payment: any;
  Customer: any;
  editable: boolean;
  itemsToDelete: any[] = [];
  loaded = true;
  methodsToDelete: any[] = [];
  payment_methods: any[];
  paymentComplete = false;
  paymentMethod: any = {};
  session: any;
  unresolvedBalance = false;
  user: any;

  constructor (
    private $uibModal: LegacyUibModalService,
    @Inject(forwardRef(() => AssemblyPaymentsService)) public assemblyPaymentsApi: AssemblyPaymentsService,
    @Inject(forwardRef(() => BigDecimalService)) public bigDecimalApi: BigDecimalService,
    @Inject(forwardRef(() => BillerService)) public billerApi: BillerService,
    @Inject(forwardRef(() => CustomerFactoryService)) private customerFactoryService: CustomerFactoryService,
    @Inject(forwardRef(() => CustomerPaymentsService)) public customerPaymentApi: CustomerPaymentsService,
    @Inject(forwardRef(() => DateParserService)) private dateParsing: DateParserService,
    @Inject(forwardRef(() => TableService)) public gridAPI: TableService,
    @Inject(forwardRef(() => MessengerService)) public messengerApi: MessengerService,
    @Inject(forwardRef(() => TillpaymentsService)) public tillpaymentsApi: TillpaymentsService,
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => CompanyService)) public companyService: CompanyService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService: ConfirmService,
    @Inject(forwardRef(() => MessagesService)) private messagesService: MessagesService,
    private router: UIRouter,
    @Inject(forwardRef(() => SessionService)) private sessionService: SessionService,
    @Inject(forwardRef(() => StreamSearchService)) private streamSearchService: StreamSearchService,
    private translateService: TranslateService
  ) {}

  searchCustomers = (query: string): Promise<any> => {
    return this.streamSearchService.search('customers', query);
  }

  formatCustomer = (customer: any): string => {
    return customer?.display_name || '';
  }

  selectCustomer (customer: any): void {
    this.router.stateService.go('app.customer-payment', { customer_id: customer.id });
  }

  ngOnInit () {
    this.session = this.sessionService.base();
    this.company = this.sessionService.company();
    this.currency = this.sessionService.currency();
    this.user = this.sessionService.user();
    this.customer = this.customer || {};
    this.creditsToApply = parseFloat(this.customer.credit_balance) > 0;

    this.customer_payment = this.payment || {
      id: '', customer_id: this.customer.id, customer_payment_number: '',
      reference: '', post_date: this.dateParsing.today(), status: 'O',
      applied_amount: 0, amount: 0, note: '',
      pos_terminal_id: this.pos_terminals?.length === 1 ? this.pos_terminals[0].id : (this.user?.default_pos_terminal_id || ''),
      pos_terminal_type: this.pos_terminals?.length === 1 ? this.pos_terminals[0].terminal_type : (this.user?.default_pos_terminal_type || ''),
      moto: false,
      customer_payment_methods_attributes: [],
      customer_payment_items_attributes: [this.createEmptyItem()]
    };

    this.editable = this.customer_payment.status === 'O';
    this.Customer = this.customerFactoryService.create(this.customer);

    this.apiService.get('/invoice_payment_methods').then(methods => {
      this.payment_methods = methods;
      this.paymentMethod.payment_method = methods[0];
    });

    if (this.payment) this.addCalcFunctions();
    if (this.lostTerminalTransaction) this.handleLostTerminalTransaction();

    // Auto-add invoice from URL param
    const invoiceId = this.router.globals.params?.invoice_id;
    if (invoiceId && !this.customer_payment.id) this.addInvoices(invoiceId);
  }

  addCalcFunctions () {
    this.customer_payment.customer_payment_items_attributes?.forEach(row => {
      row.getBalance = () => {
        const balDue = new BigDecimal(row.invoice_balance_due ? row.invoice_balance_due.toString() : '0').setScale(2, BigDecimal.ROUND_HALF_UP);
        const amt = new BigDecimal(row.amount ? row.amount.toString() : '0').setScale(2, BigDecimal.ROUND_HALF_UP);
        if (balDue.isLessThanOrEqualTo(BigDecimal.ZERO)) return 0;
        return this.customer_payment.status === 'O' ? balDue.subtract(amt).toString() : balDue.toString();
      };
    });
  }

  addInvoices (invoiceId?: any) {
    if (invoiceId) {
      return this.apiService.get('/invoice', invoiceId).then(invoice => this.addInvoiceToList([invoice])).catch(err => this.messagesService.error(err));
    }
    // Open lookup modal — delegate to $uibModal since the controllers are still AJS
    if (this.Customer.isBiller()) {
      this.openBillerInvoiceLookup().then(invoices => this.addInvoiceToList(invoices));
    } else {
      this.openInvoiceLookup().then(invoices => this.addInvoiceToList(invoices));
    }
  }

  private addInvoiceToList (invoices: any[]) {
    if (!Array.isArray(invoices)) invoices = [invoices];
    invoices.forEach((invoice, i) => {
      if (!i && this.customer_payment.customer_payment_items_attributes[0]?.untouched) {
        const first = this.customer_payment.customer_payment_items_attributes[0];
        Object.assign(first, {
          invoice_id: invoice.id, invoice_number: invoice.invoice_number,
          invoice_balance_due: invoice.balance_due, invoice_post_date: invoice.post_date,
          invoice_total: invoice.total, amount: invoice.balance_due, untouched: false
        });
      } else {
        this.customer_payment.customer_payment_items_attributes.push({
          id: '', customer_payment_id: '', invoice_id: invoice.id,
          invoice_number: invoice.invoice_number, invoice_post_date: invoice.post_date,
          invoice_total: invoice.total, amount: invoice.balance_due,
          invoice_balance_due: invoice.balance_due, untouched: false,
          getBalance () {
            const bd = new BigDecimal(this.invoice_balance_due ? this.invoice_balance_due.toString() : '0').setScale(2, BigDecimal.ROUND_HALF_UP);
            const a = new BigDecimal(this.amount ? this.amount.toString() : '0').setScale(2, BigDecimal.ROUND_HALF_UP);
            return bd.isLessThanOrEqualTo(BigDecimal.ZERO) ? 0 : bd.subtract(a).toString();
          }
        });
      }
    });
    this.updateTotals();
  }

  addItem () { this.customer_payment.customer_payment_items_attributes.push(this.createEmptyItem()); }

  applyPayment () {
    if (this.paymentMethod.amount && this.paymentMethod.payment_method?.id) {
      this.customer_payment.customer_payment_methods_attributes.push({
        customer_payment_id: this.paymentMethod.payment_method.id,
        payment_type: this.paymentMethod.payment_method.payment_method,
        amount: this.paymentMethod.amount,
        reference: this.paymentMethod.reference,
        use_eftpos: this.paymentMethod.payment_method.use_eftpos
      });
      this.paymentMethod = {};
      this.updateTotals();
    } else {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SELECT_PAYMENT_TYPE_AMOUNT'), 'error');
    }
  }

  billerCreditList () {
    this.save().then(payment => {
      this.router.stateService.go('app.customer-payment', { customer_id: payment.customer_id, id: payment.id }, { inherit: false, reload: true } as any);
      this.billerApi.openLookup(this.customer.id, false);
    }).catch(err => this.messagesService.error(err));
  }

  customerSelected (customer: any) {
    this.router.stateService.go(customer.is_branch_customer ? 'app.customer-branch-payment' : 'app.customer-payment', { customer_id: customer.id });
  }

  delete () {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_PAYMENT'))
    .then(() => this.apiService.delete('/customer_payment', this.customer_payment.id))
    .then(() => { this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.PAYMENT'), 'success'); this.router.stateService.go('app.transaction-center.jobs'); })
    .catch(err => this.messagesService.error(err));
  }

  deleteItems () {
    return (this.itemsToDelete.length || this.methodsToDelete.length) && this.customer_payment.id
      ? this.apiService.patch('/customer_payment', {
          id: this.customer_payment.id, amount: this.customer_payment.amount,
          customer_payment_items_attributes: this.itemsToDelete, customer_payment_methods_attributes: this.methodsToDelete
        }, 'customer_payment').then(p => { this.itemsToDelete = []; this.methodsToDelete = []; return p; })
      : Promise.resolve();
  }

  email (sendReceipt?: boolean) {
    this.messengerApi.email({
      customer_payment_attachment_id: '', customer_payment_id: this.customer_payment.id,
      email: this.customer.email, id: this.customer.id, message: this.companyMessages?.customer_email_message,
      send_receipt: sendReceipt,
      subject: this.translateService.instant('JS_SPACE.EMAIL.VARIABLE_SUBJECT', { name: this.company.company_name, num: this.customer_payment.customer_payment_number ? ` number ${this.customer_payment.customer_payment_number}` : '', type: 'Receipt' })
    }, { bodyParamName: 'customer', factory: CustomerPaymentEmailReceiptComponent, size: 'lg', url: '/customer_payment/email_receipt' })
    .then(() => this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.EMAIL_SENT'), 'success'));
  }

  getApplied () {
    let total = BigDecimal.ZERO;
    this.customer_payment.customer_payment_items_attributes?.forEach(row => {
      total = total.add(new BigDecimal(row.amount ? row.amount.toString() : '0').setScale(2, BigDecimal.ROUND_HALF_UP));
    });
    return total ? total.toString() : '0';
  }

  getBalance () {
    const applied = new BigDecimal(this.customer_payment.applied_amount ? this.customer_payment.applied_amount.toString() : '0');
    let payments = BigDecimal.ZERO;
    this.customer_payment.customer_payment_methods_attributes?.forEach(m => { payments = payments.add(new BigDecimal(m.amount.toString())); });
    return applied.subtract(payments).toString();
  }

  getPayments () {
    let payments = BigDecimal.ZERO;
    this.customer_payment.customer_payment_methods_attributes?.forEach(m => { payments = payments.add(new BigDecimal(m.amount.toString())); });
    return payments.toString();
  }

  handleLostTerminalTransaction (payment = this.customer_payment) {
    return this.tillpaymentsApi.processSurchargeAndPayment(payment)
    .then(() => this.confirmService.notify?.({ message: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.TILLPAYMENTS.PREVIOUS_PAYMENT_TRANSACTION_FOUND') }))
    .then(() => {
      this.router.stateService.go('app.customer-payment', { customer_id: payment.customer_id, id: payment.id }, { inherit: false, reload: true } as any);
      return Promise.reject('handled');
    });
  }

  print () {
    if (this.editable) {
      this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.MUST_PROCESS_PAYMENT_BEFORE_PRINTING'))
      .then(() => this.process())
      .then(() => window.open(`${API.url}/reports/jasper_customer_receipt/${this.customer_payment.id}.pdf`, '_blank'))
      .catch(err => this.messagesService.error(err));
    } else {
      window.open(`${API.url}/reports/jasper_customer_receipt/${this.customer_payment.id}.pdf`, '_blank');
    }
  }

  printTerminalReceipt () { window.open(`${API.url}/reports/jasper_workshoppay_eftpos_receipt/${this.customer_payment.id}.pdf`, '_blank'); }

  process () {
    const bal = new BigDecimal(this.balance.toString());
    if (!bal.isZero()) { this.unresolvedBalance = true; this.messagesService.show('No Payments Exist. Please Apply Payments Totaling the Applied Total', 'error'); return Promise.reject('balance'); }

    return Promise.resolve()
    .then(() => this.companyService.hasIntegration('tillpayments-pos')
      ? this.tillpaymentsApi.doesLostTerminalPaymentExist(this.customer_payment).then(a => a ? this.handleLostTerminalTransaction(this.customer_payment) : Promise.resolve())
      : Promise.resolve())
    .then(() => this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.SAVE_PROCESS_PAYMENT')))
    .then(() => this.save())
    .then(payment => {
      this.customer_payment = payment;
      if (this.companyService.hasPOS()) {
        const amount = this.customerPaymentApi.getPosPaymentTotal(this.customer_payment);
        if (amount) {
          const amountNum = parseFloat(amount);
          if (this.companyService.hasIntegration('tillpayments-pos')) return this.tillpaymentsApi.processTransaction(this.customer_payment, amountNum, 'payment');
          if (this.companyService.hasIntegration('assembly-payments')) return this.assemblyPaymentsApi.processPayment(this.customer_payment, undefined, amountNum);
        }
      }
      return this.apiService.get('/customer_payments/process_payment', payment.id);
    })
    .then(() => this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PROCESSED.PAYMENT'), 'success'))
    .catch(err => this.messagesService.error(err))
    .finally(() => this.router.stateService.go('app.customer-payment', { customer_id: this.customer_payment.customer_id, id: this.customer_payment.id }, { inherit: false, reload: true } as any));
  }

  removeItem (index: number) {
    const deleted = this.customer_payment.customer_payment_items_attributes.splice(index, 1);
    if (this.customer_payment.id && deleted[0]?.id) { deleted[0]._destroy = '1'; this.itemsToDelete = this.itemsToDelete.concat(deleted); }
    this.updateTotals();
  }

  removePaymentMethod (index: number) {
    if (!this.editable) return;
    const deleted = this.customer_payment.customer_payment_methods_attributes.splice(index, 1);
    if (this.customer_payment.id && deleted[0]?.id) { deleted[0]._destroy = '1'; this.methodsToDelete = this.methodsToDelete.concat(deleted); }
    this.updateTotals();
  }

  save () {
    const method = this.customer_payment.id ? 'patch' : 'post';
    const url = this.customer_payment.id ? '/customer_payment' : '/customer_payments';
    return this.deleteItems()
    .then(() => this.apiService[method](url, this.customer_payment, 'customer_payment', 'customer_payment_items_attributes'))
    .then(payment => payment)
    .catch(err => this.messagesService.error(err));
  }

  submit () {
    this.save().then(payment => {
      if (!payment) return;
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.PAYMENT'), 'success');
      this.router.stateService.go('app.customer-payment', { customer_id: payment.customer_id, id: payment.id }, { inherit: false, reload: true } as any);
    });
  }

  updateTotals () {
    this.customer_payment.applied_amount = this.getApplied();
    this.customer_payment.amount = this.customer_payment.applied_amount;
    this.balance = this.getBalance();
    this.paymentMethod.amount = this.balance;
    if (new BigDecimal(this.balance).isZero()) this.unresolvedBalance = false;
  }

  viewPaymentMethods () { this.customerPaymentApi.viewPaymentMethods(this.customer_payment); }

  void () {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.VOID_PAYMENT'))
    .then(() => this.apiService.get('/customer_payments/void_payment', this.customer_payment.id))
    .then(() => { this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.VOIDED.PAYMENT'), 'success'); this.router.stateService.go('app'); })
    .catch(err => this.messagesService.error(err));
  }

  private openInvoiceLookup (): Promise<any[]> {
    return (this.$uibModal as any).open({
      controller  : 'InvoicesForPaymentCtrl',
      controllerAs: '$ctrl',
      templateUrl : InvoicesForPaymentHtml,
      windowClass : 'x-lg-modal',
      resolve     : {
        customer: () => this.customer,
        invoices: ['workshopAPI', (workshopAPI: any) => workshopAPI.get('/customers/invoice_list', [this.customer.id, 0, '*', 'P', 'I', 'post_date', 'desc'])]
      }
    }).result;
  }

  private openBillerInvoiceLookup (): Promise<any[]> {
    const customerId = this.customer.id;
    return (this.$uibModal as any).open({
      controller       : 'InvoicesForBillerPaymentCtrl',
      controllerAs     : '$ctrl',
      templateUrl      : InvoicesForBillerPaymentHtml,
      windowClass      : 'lg-modal flip-container',
      windowTemplateUrl: WindowFlipHtml,
      resolve          : {
        billers : ['workshopAPI', (workshopAPI: any) => workshopAPI.get('/customers/biller_list', [customerId, 0, '*', 'P', 'I', '*', '*', '*', 'company_name', 'desc'])],
        isVendor: false
      }
    }).result;
  }

  private createEmptyItem () {
    return {
      id: '', customer_payment_id: '', invoice_id: '', invoice_number: '',
      invoice_post_date: '', invoice_total: 0, amount: 0, invoice_balance_due: 0, untouched: true,
      getBalance () {
        const bd = new BigDecimal(this.invoice_balance_due ? this.invoice_balance_due.toString() : '0').setScale(2, BigDecimal.ROUND_HALF_UP);
        const a = new BigDecimal(this.amount ? this.amount.toString() : '0').setScale(2, BigDecimal.ROUND_HALF_UP);
        return bd.isLessThanOrEqualTo(BigDecimal.ZERO) ? 0 : bd.subtract(a).toString();
      }
    };
  }
}
